import React from 'react';

import type { StaticDatePickerProps } from '@mui/x-date-pickers';
import { StaticDatePicker } from '@mui/x-date-pickers';
import { BackArrowIcon } from 'src/components/icons/BackArrowIcon';
import { ForwardArrowIcon } from 'src/components/icons/ForwardArrowIcon';

interface AlineStaticDatePickerProps {
  className?: string;
  pickerProps?: StaticDatePickerProps;
}

export function AlineStaticDatePicker({
  className,
  pickerProps,
}: AlineStaticDatePickerProps): JSX.Element {
  return (
    <StaticDatePicker
      className={className}
      // v9 keeps `displayStaticWrapperAs`. Mobile is the default; desktop
      // hides the toolbar AND widens the year grid (yearsPerRow 3 → 4).
      displayStaticWrapperAs="desktop"
      slots={{
        actionBar: () => null,
        leftArrowIcon: BackArrowIcon,
        rightArrowIcon: ForwardArrowIcon,
      }}
      {...pickerProps}
    />
  );
}
